<template>
	<ui-modal
		icon="fal fa-list"
		:title="titleModal"
		:load-success="loader.modalSuccess"
		:load="loader.modalLoading"
		:name="name"
		@close="handleClose"
		size="xs"
	>
		<template>
			<div class="area-card">
				<div v-show="loader.body" class="loading-card">
					<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
				</div>

				<div class="body-modal">
					<p>Qual unidade reservada para esse negócio será considerada vendida?</p>
				</div>
				<div class="unit-reserves">
					<ui-reserve-wrapper-list v-model="options.reserves" :loading="false" />
				</div>

				<div class="body-modal">
					<p>
						<strong>OBS:</strong> As demais unidades terão que ser gerenciadas na lista de reservas.
					</p>
				</div>
			</div>
		</template>

		<template #footer>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit"
				>Confirmar</ui-button
			>
		</template>
	</ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiReserveWrapperList } from '@/components/ui-facilita/wrapper'
	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { reserve } from '@/services/axios'
	import { defaultGtm } from './default'

	const defaultForm = () => ({
		reserve_id: null, // suposição
		id: null,
		column: null,
		funnel_stage_id: null,
		funnel_stage_status_id: null
	})

	const defaultOptions = () => ({
		reserves: [],
	})

	const defaultLoader = () => ({
		body: false,
		modalLoading: false,
		modalSuccess: false,
	})

	export default {
		name: 'choose-unitreserve-modal',
		components: {
			uiModal,
			uiButton,
			uiLoadIndicator,
			uiReserveWrapperList,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				options: { ...defaultOptions() },
				deal: {},
				gtm: { ...defaultGtm() },
				isIframe: false 
			}
		},

		created() {
			this.$root.$on(`modal-open-${this.name}`, async (payload) => {
				this.reset()
				this.options.reserves = []

				if (!!payload && payload.id) {
					this.loader.body = true
					this.isIframe = payload?.isIframe

					const { data } = await reserve.getAllV2('', {
						where: `status:reserved,deal_id:${payload.id}`,
					})

					this.deal = data.data

					this.options.reserves =
					// ! Esse loop deveria ser uma função isolada.
						this.deal.map((reserve) => {
							const unit = reserve.unit
							const availability = unit.availability
							let description = ''

							if (unit.floor) {
								if (unit.floor == 0) description = `Térreo - `
								else description = `${unit.floor}º andar - `
							}

							if (unit.block) description += `Quadra ${unit.block} - `
							
							if (unit.infos && unit.infos.typology)
								description += `${unit.infos.typology} - `
							if (unit.garage) description += `Garagem - `
							if (unit.area) description += `${unit.area} m²`

							reserve['situation'] = unit.situation

							return {
								...reserve,
								reference: unit.number,
								title: availability.product.name || '',
								description: availability.description || description,
								check: false,
							}
						})

					this.form.id = payload.id
					this.form.funnel_stage_id = payload.funnel_stage_id
					this.form.funnel_stage_status_id = payload.funnel_stage_status_id
					this.form.column = payload.column
				}

				this.loader.body = false
			})

			// Comunica para o painel legado, quando o modal é criado
			const messagePanel = { modal: 'choose-unit-reserve', type: 'created' }
			window.parent.postMessage(messagePanel, '*');
		},

		destroyed() {
			this.$root.$off(`modal-open-${this.name}`)
		},

		computed: {
			canSubmit() {
				return !this.loader.body
			},

			titleModal() {
				const id = this.form.id ? ' – #' + this.form.id : ''
				return 'Ação necessária – Unidades Reservadas' + id
			},

			validateReserve() {
				return this.form
			},
		},

		methods: {
			closeModal() {
				this.$root.$emit(`modal-close-${this.name}`)
				this.loader.body = true
				this.handleClose()
			},

			handleClose(){
				// Essa função serve apenas para fechar o modal quando ele é aberto no panel legado
				if (this.isIframe) {
					const messagePanel = { modal: 'choose-unit-reserve', type: 'close' }
					window.parent.postMessage(messagePanel, '*');
				}
			},

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
				this.options = { ...defaultOptions() }
			},

			async submit() {
				try {
					this.loader.modalLoading = true

					const selected = this.options.reserves.filter((reserve) => reserve.check)
					const reserve_id = selected.length > 0 ? selected[0].id : null
					this.form.reserve_id = reserve_id

					// Métodos de requisição.
					this.$root.$emit(`modal-success-${this.name}`, this.form)
					this.$gtm.trackEvent(this.gtm.submit)

					// Comunica para o painel legado, quando o modal é submetido
					if (this.isIframe) {
						const messagePanel = {
							modal: 'choose-unit-reserve',
							type: 'submit',
							content: this.form
						}
						window.parent.postMessage(messagePanel, '*');
					}

					setTimeout(() => {
						this.loader.modalSuccess = true
						setTimeout(() => {
							this.closeModal()
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.modalLoading = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
